module.exports = __webpack_public_path__ + "static/img/rank2.665a5342.png";